import React, { useState, useEffect, useRef, useContext } from 'react';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import Chart, {
    AdaptiveLayout,
    CommonSeriesSettings,
    Size,
    Tooltip,
} from 'devextreme-react/chart';
import PivotGrid, {
    FieldChooser,
    FieldPanel,
} from 'devextreme-react/pivot-grid';
import { locale } from 'devextreme/localization';

import * as COM from '.';
import * as Antd from 'antd';
import { AuthContext } from '../../containers/App';

export const DatasetPivotGrid = (props) => {

    const chartRef = useRef(null);
    const pivotGridRef = useRef(null);

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    let auth = useContext(AuthContext);

    const dataSource = new PivotGridDataSource({
        store: data,
        fields: props.fields,
        onChanged: () => {
            props.onChangedPivotGridDataSource && props.onChangedPivotGridDataSource(dataSource.state())
        }
    });

    const loadData = async (filters = null) => {
        setLoading(true);
        let data = await COM.fetchData({
            connector: props.connector,
            dataset: props.dataset,
            filters: props.filters ? props.filters : {}
        }, auth, false);
        setData(data);
        setLoading(false);
        return data;
    };

    const currencyFormatter = new Intl.NumberFormat(
        'cz-CS', {
        style: 'decimal',
        minimumFractionDigits: 0,
    },
    );

    const customizeTooltip = (args) => {
        const valueText = currencyFormatter.format(args.originalValue);
        return {
            html: `${args.seriesName} | Total<div class="currency">${valueText}</div>`,
        };
    }

    useEffect(() => {
        loadData();
        locale(navigator.language);
        if (props.showChart) {
            pivotGridRef.current.instance.bindChart(chartRef.current.instance, {
                dataFieldsDisplayMode: 'splitPanes',
                alternateDataFields: false,
            });
        }
    }, props.invalidateEffect ? props.invalidateEffect : []);

    return (
        <>
            <Antd.Spin
                spinning={loading}
            >
                {props.showChart
                    ? <Chart
                        ref={chartRef}
                        style={{
                            marginBottom: 20
                        }}
                    >
                        <Size height={150} />
                        <Tooltip enabled={true} customizeTooltip={customizeTooltip} />
                        <CommonSeriesSettings type="bar" />
                        <AdaptiveLayout width={450} />
                    </Chart>
                    : null}
                <PivotGrid
                    ref={pivotGridRef}
                    dataSource={!loading
                        ? dataSource
                        : null}
                    allowSorting={true}
                    allowSortingBySummary={true}
                    allowFiltering={true}
                    showBorders={true}
                    showColumnTotals={true}
                    showColumnGrandTotals={true}
                    showRowTotals={true}
                    showRowGrandTotals={true}
                    height={475}
                    loadPanel={{
                        enabled: loading
                    }}
                    export={{
                        enabled: true,
                        fileName: `${props.dataset}_${props.name ? props.name : 'default'}`,
                    }}
                    {...props.pivotGridProps}
                >
                    {props.showFieldChooser
                        ? <FieldChooser
                            enabled={true}
                            width={750}
                            height={600}
                            {...props.fieldChooserProps}
                        />
                        : null}
                    {props.showFieldPanel
                        ? <FieldPanel
                            showColumnFields={true}
                            showDataFields={true}
                            showFilterFields={true}
                            showRowFields={true}
                            allowFieldDragging={true}
                            visible={true}
                            {...props.fieldPanelProps}
                        />
                        : null}
                </PivotGrid>
            </Antd.Spin>
        </>
    );
}

